module.exports = __webpack_public_path__ + "static/media/sort-arrow.d3a53377.svg";